import Vue from 'vue'
import Router from 'vue-router'

import NotFound from '@/pages/NotFound'

import RouterView from '@/pages/RouterView'

import Login from '@/pages/account/Login'

import PageIndex from '@/pages/PageIndex'

import Index from '@/pages/Index'

import OperateDetailsPage from '@/pages/operate/OperateDetailsPage'

import ButtonManage from '@/pages/sys/ButtonManage'

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login,
        meta: {
          requireAuth: true
        }
    }, 
    {
        path: '*',
        component: NotFound
    },
    {
        path: '/index',
        name: 'PageIndex',
        component: PageIndex,
        meta: {
          requireAuth: true
        },
        children: [
            {
                path: '/index',
                name: 'Index',
                component: Index
            }, 
        ]
    },
    {
        path: '/ItemDetails',
        name: 'ItemDetail',
        component: OperateDetailsPage,
        meta: {
            requireAuth: true
        },
    }
]

const router = new Router({routes})


router.beforeEach((to, from, next) => {
    if (to.matched.some((r) => r.meta.requireAuth)) {
        if (to.name !== 'Login') {
            if (sessionStorage.getItem('isLogin')) {   //判断是否已经登录
                next();
            } else {
                next({
                    path: '/'
                })
            }
        } else {
            if (sessionStorage.getItem('isLogin')) {   //判断是否已经登录
                next({
                    path: '/index'
                })
            } else {
                next()
            }
        }
    } else {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js